import { useLocalization } from "@fluent/react";
import { ContentCard } from "@narmi/design_system";
import { catcat as cc } from "cerulean";
import type { FormattedBulkTemplate } from "byzantine/src/dbbl/businessLogic/entities/bulkTemplates/types";
import {
  getTemplateNetTotal,
  getTemplateAccountDisplay,
} from "./templateHelpers";
import styles from "../CreateBulk.module.scss";

const TemplateDetailsCard = ({
  template,
}: {
  template: FormattedBulkTemplate;
}) => {
  const { l10n } = useLocalization();

  const netTotal = getTemplateNetTotal(template);
  const accountDisplay = getTemplateAccountDisplay(template);

  return (
    <div className="margin--top--xl margin--bottom--xl">
      <ContentCard kind="bordered" paddingSize="none">
        <div className={cc(styles.cardSectionHeader, styles.cardSection)}>
          <p className="fontWeight--semibold margin--bottom--xs">
            {l10n.getString("bulk-template-details-header", {
              name: template.name,
            })}
          </p>
          <p className="fontSize--s fontColor--secondary">
            {l10n.getString("bulk-template-payment-count", {
              count: template.paymentCount,
            })}
            {netTotal && (
              <>
                <span
                  className={`narmi-icon-solid-circle ${styles.separator}`}
                />
                {netTotal}
              </>
            )}
          </p>
        </div>
        <div className={styles.cardSection}>
          {accountDisplay && (
            <div className={styles.cardDetailItem}>
              <p className="fontSize--s fontColor--secondary">
                {l10n.getString("label-originating-account")}
              </p>
              <p className="fontWeight--semibold">{accountDisplay}</p>
            </div>
          )}
          {template.entryDesc && (
            <div className={styles.cardDetailItem}>
              <p className="fontSize--s fontColor--secondary">
                {l10n.getString("label-entry-description")}
              </p>
              <p className="fontWeight--semibold">{template.entryDesc}</p>
            </div>
          )}
          {template.secCode && (
            <div className={styles.cardDetailItem}>
              <p className="fontSize--s fontColor--secondary">
                {l10n.getString("label-payment-type")}
              </p>
              <p className="fontWeight--semibold">{template.secCode}</p>
            </div>
          )}
          {template.description && (
            <div className={styles.cardDetailItem}>
              <p className="fontSize--s fontColor--secondary">
                {l10n.getString("label-internal-note")}
              </p>
              <p className="fontWeight--semibold">{template.description}</p>
            </div>
          )}
        </div>
      </ContentCard>
    </div>
  );
};

export default TemplateDetailsCard;
